import FormInputComponent from './FormInputComponent';

export default FormInputComponent;
